import React, { useState, useEffect, useMemo } from 'react';
import './assets/createNode.css'
import LeftChevron from './assets/chevron-left.svg';
import { Button, DatePicker, Form, Input, Radio, Select } from 'antd';



function EditNode(props) {

	const BASE_URL = process.env.REACT_APP_BASE_URL;

	const [form] = Form.useForm();

	const { TextArea } = Input;

	const [nodeName, setNodeName] = useState(props.currNode.db_node_name)

	const [nodeClass, setNodeClass] = useState(props.currNode.db_node_class)

	const [engine, setEngine] = useState(props.currNode.db_engine)

	const [endPoint, setEndPoint] = useState(props.currNode.db_endpoint)

	const [storage, setStorage] = useState(props.currNode.db_storage)

	const [createdTime, setCreatedTime] = useState(props.currNode.db_node_created_time)

	const [cloudProvider, setCloudProvider] = useState(props.currNode.db_host_cloud_provider)

	const [backupRetention, setBackupRetention] = useState(props.currNode.db_backup_retention_period)

	const [availability, setAvailability] = useState(props.currNode.db_availability_zone)

	const [engineVersion, setEngineVersion] = useState(props.currNode.db_engine_version)

	const [environment, setEnvironment] = useState(props.currNode.db_env)

	const [clusterName, setClusterName] = useState(props.currNode.db_cluster_name)

	const [inventoryUniqId, setInventoryUniqId] = useState(props.currNode.db_inv_uuid)

	const [nodeRegion, setNodeRegion] = useState(props.currNode.db_node_region)

	const [subscriptionAccount, setSubscriptionAccount] = useState(props.currNode.db_subscription_account_name)

	const [nodeDeleteProtection, setNodeDeleteProtection] = useState(props.currNode.db_node_delete_protection_flag)

	const [product, setProduct] = useState(props.currNode.db_product)

	const [module, setModule] = useState(props.currNode.db_module)

	const [status, setStatus] = useState(props.currNode.db_status)

	const [miscellaneous, setMiscellaneous] = useState(props.currNode.db_misc)

	const [comments, setComments] = useState(props.currNode.db_comments)

	const [editDisabled, setEditDisabled] = useState(false)


	function handleClose() {
		props.handleClose()
	}

	function handleNodeName(e) {
		setNodeName(e.target.value)
	}

	function handleNodeClass(e) {
		setNodeClass(e.target.value)
	}

	function handleEngine(e) {
		setEngine(e)
	}

	function handleEndPoint(e) {
		setEndPoint(e.target.value)
	}

	function handleStorage(e) {
		setStorage(e.target.value)
	}

	function handleBackupRetention(e) {
		setBackupRetention(e.target.value)
	}

	function handleAvailability(e) {
		setAvailability(e.target.value)
	}

	function handleEngineVersion(e) {
		setEngineVersion(e.target.value)
	}

	function handleCloudProvider(e) {
		setCloudProvider(e.target.value)
	}

	function handleEnvironment(e) {
		setEnvironment(e)
	}

	function handleClusterName(e) {
		setClusterName(e.target.value)
	}

	function handleInventoryUniqId(e) {
		setInventoryUniqId(e.target.value)
	}

	function handleNodeRegion(e) {
		setNodeRegion(e.target.value)
	}

	function handleSubscriptionAccount(e) {
		setSubscriptionAccount(e.target.value)
	}

	function handleProduct(e) {
		setProduct(e)
	}

	function handleNodeDeleteProtection(e) {
		setNodeDeleteProtection(e.target.value)
	}

	function handleModule(e) {
		setModule(e)
	}

	function handleStatus(e) {
		setStatus(e.target.value)
	}

	function handleMiscellaneous(e) {
		setMiscellaneous(e.target.value)
	}

	function handleComments(e) {
		setComments(e.target.value)
	}


	useEffect(() => {
		console.log(miscellaneous)
		console.log(comments)
		if( !miscellaneous) {
			setMiscellaneous("")
		}
		if( !comments) {
			setComments("")
		}

	},[miscellaneous, comments])

	function handleEditNode() {
		console.log(props.currNode)
		setEditDisabled(true)
		var apikey = localStorage.getItem('db_portal_app_apikey')
   		var oauth_token = localStorage.getItem('db_portal_oauth_token')
		fetch( BASE_URL + '/v1/inventory' ,{
	    			method : 'PUT',
	    			headers : {
	    				'Accept':'application/json',
	        			'Content-Type':'application/json',
	    				'x-api-key' : apikey,
	    				'oauth-token' : oauth_token
	    			},
	    			body : JSON.stringify({
	            "db_node_name": nodeName,
	            "db_node_class" : nodeClass,
	            "db_engine" : engine,
	            "db_endpoint" : endPoint,
	            "db_storage" : storage,
	            "db_node_created_time" : "",
	            "db_backup_retention_period" : backupRetention,
	            "db_availability_zone" : availability,
	            "db_engine_version" : engineVersion,
	            "db_host_cloud_provider": cloudProvider,
	            "db_node_region" : nodeRegion,
	            "db_status" : status,
	            "db_subscription_account_name" : subscriptionAccount,
	            "db_product" : product,
	            "db_module" : module,
	            "db_misc" : miscellaneous,
	            "db_comments" : comments,
	            "db_cluster_name" : clusterName,
	            "db_node_delete_protection_flag" : nodeDeleteProtection,
	            "db_env" : environment,
	            "db_inv_uuid": inventoryUniqId,
	            "inventory_id" : props.currNode.inventory_id
	        })
	    	})
	    	.then(res =>
	    		res.json())
	    	.then((data) => {
	    			setEditDisabled(false)
	    			props.handleSuccess()
	    	})
	    	.catch(console.log)
	}

	return (
			<div className="App-DI-create-node-container">
				<div className="App-DI-create-node-modal-content">
					<div className="App-DI-create-node-modal-header">
		 				<div className="App-DI-create-node-modal-back-icon" onClick={handleClose}>
		 					<img src={LeftChevron} />
		 				</div>
 						<div className="App-DI-create-node-modal-header-content"> Edit Node </div>
					</div>
					<div className="App-DI-create-node-modal-body">
						<div className="App-DI-create-node-form-container">
						<Form
      						form={form}
      						layout="vertical"
      					>
      						<Form.Item label="Node Name">
        						<Input placeholder={nodeName} onChange={handleNodeName} disabled />
      						</Form.Item>
      						<div className="inline">
      							<Form.Item label="Node Class" style={{marginRight:'auto'}}>
        							<Input placeholder={nodeClass} onChange={handleNodeClass} disabled/>
      							</Form.Item>
      							<Form.Item label="Engine">
      								<Select placeholder={engine} options={props.defaultFilterValues.engine} onChange={handleEngine} />
      							</Form.Item>
      						</div>
      						<Form.Item label="End Point">
        						<Input placeholder={endPoint} onChange={handleEndPoint}  disabled/>
      						</Form.Item>
      						<div className="inline">
      							<Form.Item label="Storage" style={{marginRight:'auto'}}>
        							<Input placeholder={storage} onChange={handleStorage} />
      							</Form.Item>
      							<Form.Item label="Node Created Time">
        							<DatePicker  style={{display:'flex'}} disabled/>
      							</Form.Item>
      						</div>
      						<div className="inline">
      							<Form.Item label="Backup Retention Period" style={{marginRight:'auto'}}>
        							<Input placeholder={backupRetention} onChange={handleBackupRetention} disabled/>
      							</Form.Item>
      							<Form.Item label="Availability Zone">
        							<Input placeholder={availability} onChange={handleAvailability} disabled />
      							</Form.Item>
      						</div>
      						<div className="inline">
      							<Form.Item label="Engine Version" style={{marginRight:'auto'}}>
        							<Input placeholder={engineVersion} onChange={handleEngineVersion} />
      							</Form.Item>
      							<Form.Item label="Environment">
      								<Select placeholder={environment} options={props.defaultFilterValues.env} onChange={handleEnvironment} />
      							</Form.Item>
      						</div>
      						<Form.Item label="Cluster Name">
        						<Input placeholder={clusterName} onChange={handleClusterName} />
      						</Form.Item>
      						<div className="inline">
      							<Form.Item label="Inventory Unique Id" style={{marginRight:'auto'}}>
        							<Input placeholder={inventoryUniqId} onChange={handleInventoryUniqId} disabled/>
      							</Form.Item>
      							<Form.Item label="Node Region">
        							<Input placeholder={nodeRegion} onChange={handleNodeRegion} disabled/>
      							</Form.Item>
      						</div>
      						<div className="inline">
      							<Form.Item label="Node Delete Protection Flag" style={{marginRight:'auto'}}>
        							<Input placeholder={nodeDeleteProtection} onChange={handleNodeDeleteProtection} disabled/>
      							</Form.Item>
      							<Form.Item label="Host Cloud Provider">
        							<Input placeholder={cloudProvider} onChange={handleCloudProvider} disabled />
      							</Form.Item>
      						</div>
      						<div className="inline">
      							<Form.Item label="Subscription Account Name" style={{marginRight:'auto'}}>
        							<Input placeholder={subscriptionAccount} onChange={handleSubscriptionAccount} disabled />
      							</Form.Item>
      							<Form.Item label="Product">
      								<Select defaultValue={product} options={props.defaultFilterValues.product} onChange={handleProduct} />
      							</Form.Item>
      						</div>
      						<div className="inline">
      							<Form.Item label="Module" style={{marginRight:'auto'}}>
      								<Select defaultValue={module} options={props.defaultFilterValues.module} onChange={handleModule} />
      							</Form.Item>
      							<Form.Item label="Status">
        							<Input placeholder={status} onChange={handleStatus} disabled />
      							</Form.Item>
      						</div>
      						<Form.Item label="Miscellaneous">
					          <TextArea rows={4} placeholder={miscellaneous} onChange={handleMiscellaneous} />
					        </Form.Item>
					        <Form.Item label="Comments" style={{marginBottom : '100px'}}>
					          <TextArea rows={4} placeholder={comments} onChange={handleComments} />
					        </Form.Item>
      					</Form>
      					</div>
					</div>
					<div className="App-DI-create-node-modal-footer">
						<div className="App-DI-create-node-footer-button-container">
							<Button 
	              				onClick = {() => handleClose()}
	              			>
	              				Cancel
	            			</Button>
	            			<Button
	            				type='primary'
	            				disabled = {editDisabled}
	              				onClick = {() => handleEditNode()}
	              			>
	              				Save
	            			</Button>
            			</div>
					</div>
				</div>
			</div>
		)

}

export default EditNode
